import {
	colorPalette,
	fontSize,
	fontWeight,
	mainLinks,
	supporter,
	fontFamily,
} from '../../config';
import {
	participateLogoImg,
	recogLogoImg,
	infoLogoImg,
	recordLogoImg,
	notifyLogoImg,
	support1,
	support2,
	cbsImg,
	gyeongSangImg,
	jinjuImg,
	courseImg,
} from '../../config/images';

const dateTextProps = {
	title: {
		fontSize: {
			desktop: fontSize.xl5,
			tablet: '30px',
			mobile: '24px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.bold,
		shadow: `0 0 10px rgba(0, 0, 0, 0.7);`,
	},
	unit: {
		fontSize: {
			desktop: fontSize.xl2,
			tablet: '22px',
			mobile: '20px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.bold,
		opacity: 0.8,
		shadow: `0 0 10px rgba(0, 0, 0, 0.7);`,
	},
	value: {
		fontSize: {
			desktop: fontSize.xl7,
			tablet: '44px',
			mobile: '38px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.bold,
		shadow: `0 0 10px rgba(0, 0, 0, 0.7);`,
	},
};

export const firstProps = {
	title: {
		type: 'h2',
		children: `2026 여수 일레븐브리지마라톤 대회`,
		fontSize: {
			desktop: fontSize.xl6,
			tablet: '45px',
			mobile: '24px',
		},
		fontFamily: 'Gmarket',
		color: colorPalette.white,
		fontWeight: fontWeight.medium,
		shadow: `0 0 10px rgba(0, 0, 0, 0.5);`,
	},
	content: {
		type: 'p',
		children: `2026년 11월 7일(토) 08:00 ~ 12:30\n여수시 화양면 조발전망대 광장 앞`,
		fontSize: {
			desktop: fontSize.xl2,
			tablet: '22px',
			mobile: '16px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.semiBold,
		shadow: `0 0 10px rgba(0, 0, 0, 0.6);`,
	},
	button: {
		text: {
			children: '신청하기',
			fontSize: {
				desktop: '18px',
				tablet: '22px',
				mobile: '16px',
			},
			lineHeight: 2.3,
			color: colorPalette.white,
			fontWeight: fontWeight.medium,
		},
		onClick: () =>
			(window.location.href = `${window.location.origin}/participation/person`),
		isRounded: true,
		border: `2px solid ${colorPalette.white}`,
		bgColor: 'transparent',
	},
	date: {
		title: {...dateTextProps.title, children: '행사 시작까지'},
		day: {...dateTextProps.unit, children: 'DAY'},
		dayValue: {...dateTextProps.value, children: '14'},
		hour: {...dateTextProps.unit, children: 'HOUR'},
		hourValue: {...dateTextProps.value, children: '8'},
		minute: {...dateTextProps.unit, children: 'MINUTES'},
		minuteValue: {...dateTextProps.value, children: '25'},
		second: {...dateTextProps.unit, children: 'SECONDS'},
		secondValue: {...dateTextProps.value, children: '32'},
	},
};

const secondTextProps = {
	title: {
		fontSize: {
			desktop: '26px',
			tablet: '26px',
			mobile: '26px',
		},
		color: colorPalette.primary,
		fontWeight: fontWeight.medium,
		fontFamily: 'Gmarket',
	},
	content: {
		fontSize: {
			desktop: '16px',
			tablet: '16px',
			mobile: '16px',
		},
		color: colorPalette.noneBorder,
		fontWeight: fontWeight.base,
		fontFamily: 'Gmarket',
	},
	support: {
		fontSize: {
			desktop: fontSize.xl2,
			tablet: '22px',
			mobile: '15px',
		},
		color: colorPalette.base,
		fontWeight: fontWeight.semiBold,
	},
};

export const secondProps = {
	info: {
		title: {
			...secondTextProps.title,
			children: '마라톤 알아보기',
		},
		content: {
			...secondTextProps.content,
			children: `마라톤에 도움이 되는 바로가기\n정보를 안내합니다.`,
		},
		links: mainLinks,
	},
	supports: supporter,
};

export const thirdTextProps = {
	title: {
		fontSize: {
			desktop: fontSize.xl3,
			tablet: '36px',
			mobile: '26px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.white,
		fontFamily: 'Gmarket',
	},
	description: {
		fontSize: {
			desktop: '16px',
			tablet: '16px',
			mobile: '16px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.white,
	},
	item: {
		title: {
			fontSize: {
				desktop: '20px',
				tablet: '20px',
				mobile: '18px',
			},
			color: colorPalette.realBlack,
			fontWeight: fontWeight.bold,
			lineHeight: '30px',
		},
		content: {
			fontSize: {
				desktop: '20px',
				tablet: '20px',
				mobile: '16px',
			},
			color: colorPalette.realBlack,
			fontWeight: fontWeight.normal,
			lineHeight: '30px',
		},
		smalContent: {
			fontSize: {
				desktop: fontSize.base,
				tablet: '16px',
				mobile: '16px',
			},
			color: colorPalette.tertiary,
			fontWeight: fontWeight.medium,
		},
		accentContent: {
			fontSize: {
				desktop: '20px',
				tablet: '20px',
				mobile: '16px',
			},
			color: colorPalette.tertiary,
			fontWeight: fontWeight.normal,
			lineHeight: '30px',
		},
	},
};

export const thirdProps = {
	title: {
		textAlign: 'left',
		bgColor: colorPalette.white,
		height: '3px',
		text: {...thirdTextProps.title, children: '대회요강', type: 'p'},
		description: {
			...thirdTextProps.description,
			children: '반드시 참가 유의사항을 읽고 신청해 주세요.',
		},
	},
	first: [
		{
			title: {...thirdTextProps.item.title, children: '대회명'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `2026 여수 일레븐브리지마라톤 대회`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '대회일시'},
			contents: [
				{
					...thirdTextProps.item.title,
					children: `2026년 11월 7일 (토)`,
				},
				{
					...thirdTextProps.item.content,
					children: `09:00 하프코스 출발\n09:10 10km코스 출발`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '집결시간'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `오전 8시 30분`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '장소'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `여수시 화양면 조발전망대 광장 앞`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '참가구분'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `하프코스/10km코스`,
				},
				{
					...thirdTextProps.item.content,
					children: `2가지 코스 중 선택 가능`,
				},
			],
		},
	],
	second: [
		{
			title: {...thirdTextProps.item.title, children: '참가자격'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `하프코스 18세 이상, 10km 나이제한 없음`,
				},
				{
					...thirdTextProps.item.smalContent,
					children: `대한육상경기연맹 등록선수 및 선수등록 말소 후\n2년 경과되지 않은 자는 시상에서 제외됩니다.`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '접수기간'},
			contents: [
				{
					...thirdTextProps.item.title,
					children: `2026년 10월 23일 (금) 23:59까지`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '접수방법'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `인터넷으로만 접수`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '모집인원'},
			contents: [
				{
					...thirdTextProps.item.accentContent,
					children: `하프코스, 10km코스\n선착순 1011명`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '참가비'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `하프코스 - 45,000원\n10km코스 - 45,000원`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '입금계좌'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `농협 351-1091-5390-03 \n일레븐브리지마라톤 조직위원회`,
				},
			],
		},
	],
};

const fourthTextProps = {
	title: {
		fontSize: {
			desktop: fontSize.xl3,
			tablet: '36px',
			mobile: '24px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.black,
		fontFamily: 'Gmarket',
	},
	description: {
		fontSize: {
			desktop: '16px',
			tablet: '16px',
			mobile: ' 16px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.engTitle,
	},
};

export const fourthProps = {
	title: {
		textAlign: 'left',
		bgColor: colorPalette.primary,
		height: '5px',
		text: {...fourthTextProps.title, children: '대회코스', type: 'p'},
		description: {
			...fourthTextProps.description,
			children: '대회 구간을 참고하시고 신청 바랍니다',
			// children: '준비 중',
		},
	},
	course: {
		src: courseImg,
		alt: '코스',
		borderRadius: '1.375rem',
	},
};

export const modalProps = {
	isClose: true,
	imgs: [{src: courseImg}, {src: ''}],
};
